import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = /*#__PURE__*/ _createElementVNode("div", { class: "form-details" }, [
    /*#__PURE__*/ _createElementVNode("div", { class: "form-title" }, [
        /*#__PURE__*/ _createElementVNode("h2", null, "\r\n\t\t\t\t\tEvents\r\n\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "clearfix" };
const _hoisted_5 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_6 = { class: "input-group top_search" };
const _hoisted_7 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_8 = { class: "input-group top_search" };
const _hoisted_9 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_10 = { class: "input-group top_search" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12 col-md-3" };
const _hoisted_12 = {
    key: 0,
    class: "btn-group pw100"
};
const _hoisted_13 = {
    key: 1,
    class: "row left-10 right-10"
};
const _hoisted_14 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_15 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_16 = { class: "col-xs-12 col-sm-12 col-md-6" };
const _hoisted_17 = /*#__PURE__*/ _createElementVNode("div", { class: "input-group-append input-group-btn" }, [
    /*#__PURE__*/ _createElementVNode("button", {
        type: "button",
        class: "btn btn-default",
        "data-toggle": ""
    }, [
        /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-calendar" })
    ])
], -1 /* HOISTED */);
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("div", { class: "clearfix" }, null, -1 /* HOISTED */);
const _hoisted_19 = {
    key: 0,
    class: "col-xs-12 col-sm-12 col-md-12"
};
const _hoisted_20 = { class: "clearfix data-grid-top-pagination" };
const _hoisted_21 = { class: "float-end" };
const _hoisted_22 = { class: "float-end hidden-xs record-count" };
const _hoisted_23 = { class: "col-xs-12 col-sm-12" };
const _hoisted_24 = { class: "card bg-white data-grid events-grid detached overflow-x-auto" };
const _hoisted_25 = {
    id: "eventsTable",
    class: "table table-hover border-collapse-separate bottom0"
};
const _hoisted_26 = { class: "max-width300" };
const _hoisted_27 = { class: "hidden-sm" };
const _hoisted_28 = { class: "hidden-sm" };
const _hoisted_29 = { class: "hidden-sm" };
const _hoisted_30 = { class: "hidden-sm" };
const _hoisted_31 = { class: "hidden-sm" };
const _hoisted_32 = ["onClick"];
const _hoisted_33 = { class: "hidden-sm" };
const _hoisted_34 = { class: "clearfix visible-sm" };
const _hoisted_35 = { class: "blue lead" };
const _hoisted_36 = { class: "clearfix" };
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-clock-o" }, null, -1 /* HOISTED */);
const _hoisted_38 = { class: "clearfix" };
const _hoisted_39 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-paper-plane" }, null, -1 /* HOISTED */);
const _hoisted_40 = { class: "hidden-sm" };
const _hoisted_41 = { class: "hidden-sm" };
const _hoisted_42 = { class: "hidden-sm" };
const _hoisted_43 = { class: "hidden-sm" };
const _hoisted_44 = { class: "hidden-sm" };
const _hoisted_45 = { key: 0 };
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("td", {
    class: "text-center hidden-sm",
    colspan: "8"
}, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_47 = /*#__PURE__*/ _createElementVNode("td", { class: "text-center visible-sm" }, [
    /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t")
], -1 /* HOISTED */);
const _hoisted_48 = { class: "clearfix" };
const _hoisted_49 = { class: "x_panel" };
const _hoisted_50 = { class: "x_content" };
const _hoisted_51 = { class: "d-block" };
const _hoisted_52 = /*#__PURE__*/ _createElementVNode("label", null, "First Alarm raised on:", -1 /* HOISTED */);
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("label", null, " | Last Alarm raised on: ", -1 /* HOISTED */);
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-question-circle-o",
    "aria-hidden": "true",
    title: "Total duration since the initial alarm was raised, to when the final alarm was raised. In addition to the designated time window."
}, null, -1 /* HOISTED */);
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("i", {
    class: "fa fa-question-circle-o",
    "aria-hidden": "true",
    title: "Total duration since the initial alarm was raised, to the clearing of the final alarm."
}, null, -1 /* HOISTED */);
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("label", null, "Notes", -1 /* HOISTED */);
const _hoisted_57 = { class: "float-end" };
const _hoisted_58 = { id: "current" };
const _hoisted_59 = { id: "maximum" };
const _hoisted_60 = { class: "clearfix card" };
const _hoisted_61 = { class: "clearfix card-header" };
const _hoisted_62 = { class: "d-flex float-start" };
const _hoisted_63 = /*#__PURE__*/ _createElementVNode("h2", { class: "m-0 me-3" }, "Alarms", -1 /* HOISTED */);
const _hoisted_64 = { style: { "margin-top": "2px" } };
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("label", { class: "m-0" }, "Active: ", -1 /* HOISTED */);
const _hoisted_66 = /*#__PURE__*/ _createElementVNode("label", { class: "m-0" }, " Total: ", -1 /* HOISTED */);
const _hoisted_67 = { class: "float-end" };
const _hoisted_68 = {
    key: 0,
    class: "clearfix card-body p-0"
};
const _hoisted_69 = { class: "card bg-white data-grid event-alarms-grid overflow-x-auto m-0" };
const _hoisted_70 = { class: "table table-hover bottom0 border-collapse-separate" };
const _hoisted_71 = /*#__PURE__*/ _createElementVNode("thead", null, [
    /*#__PURE__*/ _createElementVNode("tr", null, [
        /*#__PURE__*/ _createElementVNode("th", { class: "alarm-border" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tTime\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tLocation\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tDescription\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tState\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t"),
        /*#__PURE__*/ _createTextVNode(),
        /*#__PURE__*/ _createElementVNode("th", { class: "text-end" }, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tValue\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_72 = { class: "text-end" };
const _hoisted_73 = { key: 0 };
const _hoisted_74 = /*#__PURE__*/ _createElementVNode("tr", null, [
    /*#__PURE__*/ _createElementVNode("td", {
        colspan: "5",
        class: "text-center"
    }, [
        /*#__PURE__*/ _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tThere are no alarms at this time.\r\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t")
    ])
], -1 /* HOISTED */);
const _hoisted_75 = [
    _hoisted_74
];
const _hoisted_76 = { class: "float-end float-start-sm" };
const _hoisted_77 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* HOISTED */);
const _hoisted_78 = /*#__PURE__*/ _createElementVNode("i", { class: "fa fa-times" }, null, -1 /* HOISTED */);
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_multiselect = _resolveComponent("multiselect");
    const _component_b_button = _resolveComponent("b-button");
    const _component_flat_pickr = _resolveComponent("flat-pickr");
    const _component_b_input_group_append = _resolveComponent("b-input-group-append");
    const _component_b_input_group = _resolveComponent("b-input-group");
    const _component_b_pagination = _resolveComponent("b-pagination");
    const _component_SortableColumnComponent = _resolveComponent("SortableColumnComponent");
    const _component_b_form_textarea = _resolveComponent("b-form-textarea");
    const _component_router_link = _resolveComponent("router-link");
    const _component_b_container = _resolveComponent("b-container");
    const _component_b_modal = _resolveComponent("b-modal");
    const _component_StatusOverlayComponent = _resolveComponent("StatusOverlayComponent");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createTextVNode(),
        _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.selectedCompanyId,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.selectedCompanyId) = $event)),
                            options: _ctx.companies,
                            "track-by": "value",
                            label: "text",
                            showLabels: false,
                            placeholder: "All companies",
                            class: "multiselect-small"
                        }, {
                            noResult: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.siteId,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.siteId) = $event)),
                            options: _ctx.sitesFiltered,
                            "track-by": "value",
                            label: "text",
                            showLabels: false,
                            placeholder: "All sites",
                            class: "multiselect-small"
                        }, {
                            noResult: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_multiselect, {
                            modelValue: _ctx.selectedSystemId,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.selectedSystemId) = $event)),
                            options: _ctx.systemsFiltered,
                            "track-by": "systemId",
                            label: "displayName",
                            showLabels: false,
                            placeholder: "All systems",
                            class: "multiselect-small"
                        }, {
                            noResult: _withCtx(() => [
                                _createTextVNode("\r\n\t\t\t\t\t\t\t\tNo results found\r\n\t\t\t\t\t\t\t")
                            ]),
                            _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["modelValue", "options"])
                    ])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_11, [
                    (!_ctx.showDatePickers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateFilterOptions, (item, idx) => {
                                return (_openBlock(), _createBlock(_component_b_button, {
                                    class: "pw100",
                                    disabled: _ctx.working,
                                    key: idx,
                                    variant: _ctx.dateFilterOption == item ? 'primary' : 'outline-secondary',
                                    onClick: ($event) => (_ctx.setDateFilterOption(item))
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(item), 1 /* TEXT */)
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "variant", "onClick"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ]))
                        : _createCommentVNode("v-if", true),
                    _createTextVNode(),
                    (_ctx.showDatePickers)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                                _createVNode(_component_b_input_group, {
                                    class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.startDateInvalid ? 'is-invalid' : ''])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_flat_pickr, {
                                            class: "form-control",
                                            modelValue: _ctx.query.startTime,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.query.startTime) = $event)),
                                            config: _ctx.datePickerConfig,
                                            placeholder: "From date",
                                            disabled: _ctx.working
                                        }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                            default: _withCtx(() => [
                                                _hoisted_15
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_b_input_group, {
                                    class: _normalizeClass(['top_search', _ctx.areDatesInvalid || _ctx.endDateInvalid ? 'is-invalid' : ''])
                                }, {
                                    default: _withCtx(() => [
                                        _createVNode(_component_flat_pickr, {
                                            class: "form-control",
                                            modelValue: _ctx.query.endTime,
                                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((_ctx.query.endTime) = $event)),
                                            config: _ctx.datePickerConfig,
                                            placeholder: "Until date",
                                            disabled: _ctx.working
                                        }, null, 8 /* PROPS */, ["modelValue", "config", "disabled"]),
                                        _createTextVNode(),
                                        _createVNode(_component_b_input_group_append, { class: "input-group-btn" }, {
                                            default: _withCtx(() => [
                                                _hoisted_17,
                                                _createTextVNode(),
                                                _createElementVNode("button", {
                                                    type: "button",
                                                    class: "btn btn-secondary",
                                                    onClick: _cache[5] || (_cache[5] =
                                                        //@ts-ignore
                                                        (...args) => (_ctx.resetDateFilterOption && _ctx.resetDateFilterOption(...args)))
                                                }, "\r\n\t\t\t\t\t\t\t\t\t\t...\r\n\t\t\t\t\t\t\t\t\t")
                                            ]),
                                            _: 1 /* STABLE */
                                        })
                                    ]),
                                    _: 1 /* STABLE */
                                }, 8 /* PROPS */, ["class"])
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
                ])
            ]),
            _createTextVNode(),
            _hoisted_18,
            _createTextVNode(),
            (_ctx.searchAttempted)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_b_pagination, {
                                class: "float-end",
                                modelValue: _ctx.query.pageNo,
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.query.pageNo) = $event)),
                                "per-page": _ctx.query.pageSize,
                                "total-rows": _ctx.data.recordCount,
                                "hide-ellipsis": true,
                                disabled: _ctx.working
                            }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_22, "\r\n\t\t\t\t\t\tItems: " + _toDisplayString(_ctx.data.recordCount), 1 /* TEXT */)
                    ])
                ]))
                : _createCommentVNode("v-if", true),
            _createTextVNode(),
            _withDirectives(_createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("table", _hoisted_25, [
                        _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", _hoisted_26, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'whenFirstAlarmRaised', title: 'First Alarm', visible: true }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_27, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'whenLastAlarmRaised', title: 'Last Alarm', visible: true }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_28, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'systemName', title: 'System' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_29, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'eventTypeName', title: 'Event Type' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_30, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'status', title: 'Status' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ]),
                                _createTextVNode(),
                                _createElementVNode("th", _hoisted_31, [
                                    _createVNode(_component_SortableColumnComponent, {
                                        sorter: _ctx.sorter,
                                        column: { fieldName: 'siteName', title: 'Site' }
                                    }, null, 8 /* PROPS */, ["sorter"])
                                ])
                            ])
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                return (_openBlock(), _createElementBlock("tr", {
                                    class: "pointer",
                                    onClick: ($event) => (_ctx.view(item))
                                }, [
                                    _createElementVNode("td", null, [
                                        _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.formatDateTime(item.whenFirstAlarmRaised)), 1 /* TEXT */),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_34, [
                                            _createElementVNode("span", _hoisted_35, _toDisplayString(item.eventTypeName), 1 /* TEXT */),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_36, [
                                                _hoisted_37,
                                                _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(item.whenCreated)), 1 /* TEXT */)
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_38, [
                                                _hoisted_39,
                                                _createTextVNode(" " + _toDisplayString(_ctx.getEventStatusDescription(item)), 1 /* TEXT */)
                                            ])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.formatDateTime(item.whenLastAlarmRaised)), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_41, _toDisplayString(item.systemName), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_42, _toDisplayString(item.eventTypeName), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_43, _toDisplayString(_ctx.getEventStatusDescription(item)), 1 /* TEXT */),
                                    _createTextVNode(),
                                    _createElementVNode("td", _hoisted_44, _toDisplayString(item.siteName), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_32));
                            }), 256 /* UNKEYED_FRAGMENT */))
                        ]),
                        _createTextVNode(),
                        _createElementVNode("tfoot", null, [
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_45, [
                                    _hoisted_46,
                                    _createTextVNode(),
                                    _hoisted_47
                                ]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ])
                ])
            ], 512 /* NEED_PATCH */), [
                [_vShow, _ctx.searchAttempted]
            ])
        ]),
        _createTextVNode(),
        _createVNode(_component_b_modal, {
            class: "modal-form-lg",
            id: "event_popup",
            modelValue: _ctx.showEventPopUp,
            "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event) => ((_ctx.showEventPopUp) = $event)),
            "header-bg-variant": "normal",
            size: "xl"
        }, {
            title: _withCtx(() => [
                _createTextVNode("\r\n\t\t\t\tEvent " + _toDisplayString(_ctx.eventModel.eventTypeName) + ": " + _toDisplayString(_ctx.getEventStatusDescription(_ctx.eventModel)), 1 /* TEXT */)
            ]),
            footer: _withCtx(() => [
                _createElementVNode("div", _hoisted_76, [
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "primary",
                        onClick: _ctx.save
                    }, {
                        default: _withCtx(() => [
                            _hoisted_77,
                            _createTextVNode(" Save\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"]),
                    _createTextVNode(),
                    _createVNode(_component_b_button, {
                        type: "button",
                        variant: "secondary",
                        onClick: _ctx.cancel
                    }, {
                        default: _withCtx(() => [
                            _hoisted_78,
                            _createTextVNode(" Cancel\r\n\t\t\t\t\t")
                        ]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ]),
            default: _withCtx(() => [
                _createTextVNode(),
                _createVNode(_component_b_container, { clearfix: "" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_48, [
                            _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("h2", null, "System: " + _toDisplayString(_ctx.eventModel.systemName), 1 /* TEXT */)
                                    ]),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_51, [
                                        _createElementVNode("div", null, [
                                            _hoisted_52,
                                            _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.eventModel.whenEventStarted)) + " ", 1 /* TEXT */),
                                            _hoisted_53,
                                            _createTextVNode(" " + _toDisplayString(_ctx.formatDateTime(_ctx.eventModel.whenLastAlarmRaised)), 1 /* TEXT */)
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("label", null, [
                                                _createTextVNode("Event Duration: " + _toDisplayString(_ctx.eventModel.durationText) + " ", 1 /* TEXT */),
                                                _hoisted_54
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", null, [
                                            _createElementVNode("label", null, [
                                                _createTextVNode("Alarms Duration: " + _toDisplayString(_ctx.eventModel.alarmsDurationText) + " ", 1 /* TEXT */),
                                                _hoisted_55
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _hoisted_56,
                                        _createTextVNode(),
                                        _createVNode(_component_b_form_textarea, {
                                            name: "notes",
                                            modelValue: _ctx.eventModel.notes,
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.eventModel.notes) = $event)),
                                            rows: "5",
                                            maxlength: _ctx.maxCommentLength
                                        }, null, 8 /* PROPS */, ["modelValue", "maxlength"]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_57, [
                                            _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.getCommentLength), 1 /* TEXT */),
                                            _createTextVNode(),
                                            _createElementVNode("span", _hoisted_59, "/ " + _toDisplayString(_ctx.maxCommentLength), 1 /* TEXT */)
                                        ])
                                    ])
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", null, [
                                _createElementVNode("div", _hoisted_60, [
                                    _createElementVNode("div", _hoisted_61, [
                                        _createElementVNode("div", _hoisted_62, [
                                            _hoisted_63,
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_64, [
                                                _hoisted_65,
                                                _createTextVNode(" " + _toDisplayString(_ctx.getActiveAlarmsCount()) + " |\r\n\t\t\t\t\t\t\t\t\t\t", 1 /* TEXT */),
                                                _hoisted_66,
                                                _createTextVNode(" " + _toDisplayString(_ctx.getTotalAlarmsCount()), 1 /* TEXT */)
                                            ])
                                        ]),
                                        _createTextVNode(),
                                        _createElementVNode("div", _hoisted_67, [
                                            _createElementVNode("a", {
                                                class: "collapse-link",
                                                onClick: _cache[8] || (_cache[8] = ($event) => (_ctx.alarmDetailsVisible = !_ctx.alarmDetailsVisible))
                                            }, [
                                                _createElementVNode("i", {
                                                    class: _normalizeClass(_ctx.alarmDetailsVisible ? 'fa fa-chevron-up' : 'fa fa-chevron-down')
                                                }, null, 2 /* CLASS */)
                                            ])
                                        ])
                                    ]),
                                    _createTextVNode(),
                                    _createVNode(_Transition, { name: "slide" }, {
                                        default: _withCtx(() => [
                                            (_ctx.alarmDetailsVisible)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
                                                    _createElementVNode("div", _hoisted_69, [
                                                        _createElementVNode("table", _hoisted_70, [
                                                            _hoisted_71,
                                                            _createTextVNode(),
                                                            _createElementVNode("tbody", null, [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventModel.alarms, (item) => {
                                                                    return (_openBlock(), _createElementBlock("tr", {
                                                                        class: _normalizeClass(['alarm', _ctx.alarmClass(item)])
                                                                    }, [
                                                                        _createElementVNode("td", null, [
                                                                            _createVNode(_component_router_link, {
                                                                                to: { name: 'alarms', query: { 'alarmId': item.alarmId } },
                                                                                class: "blue"
                                                                            }, {
                                                                                default: _withCtx(() => [
                                                                                    _createTextVNode(_toDisplayString(_ctx.formatDateTime(item.whenRaised)), 1 /* TEXT */)
                                                                                ]),
                                                                                _: 2 /* DYNAMIC */
                                                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to"])
                                                                        ]),
                                                                        _createTextVNode(),
                                                                        _createElementVNode("td", null, _toDisplayString(item.componentName), 1 /* TEXT */),
                                                                        _createTextVNode(),
                                                                        _createElementVNode("td", null, _toDisplayString(item.alarmDefinitionName), 1 /* TEXT */),
                                                                        _createTextVNode(),
                                                                        _createElementVNode("td", null, _toDisplayString(_ctx.getAlarmState(item)), 1 /* TEXT */),
                                                                        _createTextVNode(),
                                                                        _createElementVNode("td", _hoisted_72, _toDisplayString(_ctx.getAlarmValue(item)), 1 /* TEXT */)
                                                                    ], 2 /* CLASS */));
                                                                }), 256 /* UNKEYED_FRAGMENT */))
                                                            ]),
                                                            _createTextVNode(),
                                                            (!_ctx.eventModel.alarms || !_ctx.eventModel.alarms.length)
                                                                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_73, _hoisted_75))
                                                                : _createCommentVNode("v-if", true)
                                                        ])
                                                    ])
                                                ]))
                                                : _createCommentVNode("v-if", true)
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ])
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createTextVNode()
            ]),
            _: 1 /* STABLE */
        }, 8 /* PROPS */, ["modelValue"]),
        _createTextVNode(),
        _createVNode(_component_StatusOverlayComponent, {
            visible: _ctx.working,
            message: "Loading..."
        }, null, 8 /* PROPS */, ["visible"])
    ]));
}
